module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('xm-modal', {
    attrs: {
      "value": _vm.open,
      "title": _vm.title,
      "size": "lg",
      "id": _vm.modalName,
      "save": _vm.save,
      "save-text": _vm.saveBtnText,
      "save-disabled": !_vm.formValid || !_vm.saveValid,
      "cancel-method": _vm.cancelMethod
    },
    on: {
      "hide": function($event) {
        return _vm.$emit('closed')
      },
      "show": function($event) {
        return _vm.$emit('opened')
      }
    }
  }, [_c('div', [_c('form', [_c('form-validator', {
    model: {
      value: (_vm.formValid),
      callback: function($$v) {
        _vm.formValid = $$v
      },
      expression: "formValid"
    }
  }, [_vm._t("default")], 2)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9ab5824a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modals/FormModal.vue
// module id = 1339
// module chunks = 16